<template>
	<div class="products" v-loading="isLoading">
		<app-tab/>
		<div v-if="disabled" class="product-disabled">
			<h1
				:style="`color:${globalColors.primary}`"
				class="sorry-text"
			>Lo sentimos, este producto está desactivado  :(</h1>
		</div>
		<detail-product
			v-else
			:features="features"
			:images="images"
			:product-detail="productDetail"
			:disabled-btn="disabledBtn"
			@warehouse-event="openModal"
			@select="selectFeature"
			@change-quantity="changeQuantity"
			@favorite-event="loadData"
			@product-added="openModalAction"
			@selected-unit="selectedUnit"
		/>
		<tabs
			:disabled-product="disabled"
			:products="products"
			:tabs="tabs"
			:select="select"
			:list-questions="listQuestions"
			:list-opinions="listOpinions"
			:id="idProduct"
			@select="selectTab"
			@update="loadDataQuestion"
			@update-opinion="loadOpinion"
		/>
		<warehouse-modal
			:open-modal="dialogVisible"
			:id="productDetail.id"
			@close-modal="closeModal"
		/>
		<modal-action
			:currency="getCurrencySymbol"
			:dialog="dialog"
			:product="productModal"
			@close="closeModalAction"
			@go-to="goToCar"
		></modal-action>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import detailProduct from '@/sections/detail/product';
import tabs from '@/sections/detail/tabs';
import warehouseModal from '@/components/warehouseModal';
import appTab from '@/components/tab';
import modalAction from '@/components/modal-action';
import { priceProductConfiguration } from '@/helpers/helper';

async function created() {
	await this.loadProduct();
	this.updateDescriptionTag(this.productSelect.description);
	this.setPageTitle(this.productSelect.name);
}

function openModal() {
	this.dialogVisible = true;
}

function closeModal() {
	this.dialogVisible = false;
}

function selectTab({ name }) {
	this.tabs = this.tabs.map((tab) => {
		const newTab = { ...tab };
		newTab.active = tab.name === name;
		return newTab;
	});
	this.select = this.tabs.find(tab => tab.active);
}

function isLoggedUser() {
	if (this.token) {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		return this.$httpQtc.get(`products/favorites/${this.id}`, { headers });
	}
	return this.$httpQtc.get(`products-public/${this.id}`);
}

async function loadProduct() {
	try {
		const { data: res } = await this.isLoggedUser();
		const salPriceId = this.getCommerceData.settings.salPriceListId;
		const [dataTabs] = priceProductConfiguration(salPriceId, [res]);
		this.setUpTabs(dataTabs.sections);
		this.images = dataTabs.images;
		this.productSelect.description = dataTabs.description;
		this.productSelect.images = dataTabs.images;
		this.productSelect.price = dataTabs.price;
		this.productSelect.priceDiscount = dataTabs.priceDiscount;
		this.productSelect.rating = dataTabs.rating;
		this.productSelect.id = dataTabs.id;
		this.productSelect.quantity = 1;
		this.productSelect.name = dataTabs.name;
		this.productSelect.urlImage = dataTabs.urlImage;
		this.productSelect.model = dataTabs.model;
		this.productSelect.priceList = dataTabs.priceList;
		this.assignProduct(dataTabs);
		this.loadData(dataTabs.id);
		this.idProduct = dataTabs.id;
		this.loadDataQuestion();
		this.loadOpinion();
		this.selectedUnit(this.productDetail.unit);
	} catch (error) {
		if (error.data.message === 'PRODUCT_NOT_FOUND') {
			this.disabled = true;
			this.$message({
				message: 'Este producto ya no está disponible',
				showClose: true,
				type: 'info',
			});
			this.productsRelated(this.id);
		} else {
			this.$message({
				message: 'Error',
				showClose: true,
				type: 'error',
			});
		}
	}
}

async function productsRelated(slug) {
	const url = `products-public/${slug}/related`;
	({ data: this.products } = await this.$httpQtc.get(url));
}

async function loadData(id) {
	this.isLoading = true;
	const requests = [
		this.$httpQtc.get(`products-public/${id}/related`),
		this.$httpQtc.get(`products-public/${id}/children`),
	];
	([
		{ data: this.products },
		{ data: this.childrens },
	] = await Promise.all(requests));
	const salPriceId = this.getCommerceData.settings.salPriceListId;
	this.childrens = priceProductConfiguration(salPriceId, this.childrens);
	this.products = priceProductConfiguration(salPriceId, this.products);
	if (this.childrens.length) {
		this.disabledBtn = true;
	}
	this.childrens = this.childrens.map((children) => {
		const newChildren = { ...children };
		newChildren.quantity = 1;
		return newChildren;
	});
	this.select = this.tabs.find(tab => tab.active);
	this.allFeatures = this.childrens.reduce((acum, children) => acum.concat(children.features), []);
	this.features = this.allFeatures.reduce((acum, feature) => {
		const index = acum.findIndex(a => a.name === feature.name);
		if (index > -1) {
			const indexValue = acum[index].values.findIndex(i => i.name === feature.value);
			if (indexValue === -1) {
				acum[index].values.push({ name: feature.value, active: false, possible: false });
			}
		} else {
			acum.push({ name: feature.name,
				values: [{ name: feature.value, active: false, possible: false }] });
		}
		return acum;
	}, []);
	this.isLoading = false;
}

function selectFeature(indexOne, indexTwo) {
	this.$set(this.features[indexOne].values[indexTwo], 'active', true);
	this.featureSelect.push({ name: this.features[indexOne].name,
		value: this.features[indexOne].values[indexTwo].name });
	this.filterProduct(this.featureSelect);
}

function filterProduct(filters) {
	const numFilter = filters.length;
	this.arrayPossible = [];
	this.productsFilter = this.childrens.reduce((acum, children) => {
		const flagFilter = [];
		filters.forEach((filter) => {
			if (children.features.filter(f => f.name === filter.name &&
				f.value === filter.value).length) {
				flagFilter.push(filter);
			}
		});
		if (flagFilter.length === numFilter) {
			acum.push(children);
			children.features.forEach((element) => {
				if (this.arrayPossible.length) {
					const index = this.arrayPossible.findIndex(a => a.name === element.name
						&& a.value === element.value);
					if (index === -1) {
						this.arrayPossible.push({ name: element.name, value: element.value });
					}
				} else {
					this.arrayPossible.push({ name: element.name, value: element.value });
				}
			});
		}
		return acum;
	}, []);
	if (this.productsFilter.length === 0) {
		this.featureSelect = this.featureSelect.reduce((acum, feature, index) => {
			if (index === this.featureSelect.length - 1) {
				acum.push(feature);
			}
			return acum;
		}, []);
		this.arrayPossible = [];
		this.features = this.features.map((element, index) => {
			element.values.forEach((value, indexValue) => {
				this.$set(this.features[index].values[indexValue], 'possible', false);
				const flag = element.name === this.featureSelect[0].name &&
					value.name === this.featureSelect[0].value;
				this.$set(this.features[index].values[indexValue], 'active', flag);
			});
			return element;
		});
		this.filterProduct(this.featureSelect);
	}
	this.possibleFeature(this.arrayPossible);
}

function possibleFeature(possibles) {
	this.features = this.features.map((element, index) => {
		element.values.forEach((value, indexValue) => {
			if (this.productsFilter.length === 1) {
				const flag = possibles.filter(p => p.value === value.name);
				this.$set(this.features[index].values[indexValue], 'active', !!flag.length);
				this.$set(this.features[index].values[indexValue], 'possible', false);
			} else {
				const flag = possibles.filter(p => p.value === value.name && !value.active);
				this.$set(this.features[index].values[indexValue], 'possible', !!flag.length);
			}
		});
		return element;
	});
	if (this.productsFilter.length === 1) {
		this.assignProduct(this.productsFilter[0]);
		this.disabledBtn = false;
	} else {
		this.assignProduct(this.productSelect);
		this.disabledBtn = true;
	}
}

function assignProduct(product) {
	this.productDetail = { ...product };
	this.productDetail.quantity = 1;
}

function changeQuantity(sign) {
	let num = this.productDetail.quantity;
	const newProductdetail = { ...this.productDetail };
	if (sign === 'less' && num === 1) {
		num = 1;
	} else {
		num = sign === 'more' ? num += 1 : num -= 1;
	}
	this.$set(newProductdetail, 'quantity', num);
	this.productDetail = { ...newProductdetail };
}

function setUpTabs(sections) {
	const newSections = sections.map((s, i) => {
		const newS = { ...s };
		newS.name = s.name || s.subSections[0].name;
		newS.active = i === 0;
		newS.flag = 'service';
		return newS;
	});
	this.tabs = [].concat(newSections, this.defaultTabs);
}

function routeHandler() {
	this.loadProduct();
}

async function loadDataQuestion() {
	const params = {
		typeQuestionAnswer: 1,
		productId: this.idProduct,
	};
	try {
		const { data: response } = await this.$httpQtc.get('question-answer/public', { params });
		this.listQuestions = response;
	} catch (error) {
		this.$message({
			message: 'Error',
			showClose: true,
			type: 'error',
		});
	}
}

async function loadOpinion() {
	const params = {
		typeQuestionAnswer: 3,
		productId: this.idProduct,
	};
	try {
		const { data: response } = await this.$httpQtc.get('question-answer/public', { params });
		this.listOpinions = response;
	} catch (error) {
		this.$message({
			message: 'Error',
			showClose: true,
			type: 'error',
		});
	}
}

function openModalAction(productAdded) {
	this.isLoading = true;
	setTimeout(() => {
		this.productModal = { ...productAdded };
		this.isLoading = false;
		this.dialog = true;
	}, 1000);
}

function closeModalAction() {
	this.dialog = false;
	this.productModal = {};
}

function goToCar() {
	this.$router.push({ name: 'buy-car' });
}

function selectedUnit(unit) {
	this.productDetail.unitSelected = unit;
	this.updateImages(unit.id);
	this.updatePrices(unit.id);
}

function updateImages(unitId) {
	this.productDetail.images = this.images.filter(img => img.unitId === unitId);
	if (this.productDetail.images.length === 0) {
		this.productDetail.images = this.images;
		this.productDetail.imgPresentation = this.productDetail.urlImage;
	} else {
		this.productDetail.imgPresentation = this.productDetail.images[0].urlImage;
	}
}

function updatePrices(unitId) {
	if (unitId === this.productDetail.unitId) {
		const { discount, price } = this.productDetail.priceList[this.commercePriceList];
		this.setProductPrices(discount, price);
	} else {
		const { units } = this.productDetail.priceList[this.commercePriceList];
		const { discount, price } = units[unitId] || {};
		this.setProductPrices(discount, price);
	}
}

function setProductPrices(discount, price) {
	this.productDetail.price = discount ? price : 0;
	const priceDiscount = discount ? Number((price * ((100 - discount) / 100)).toFixed(2)) : price;
	this.productDetail.priceDiscount = priceDiscount;
}

function data() {
	return {
		defaultTabs: [
			{ name: 'PREGUNTAS Y RESPUESTAS', active: false, flag: 'questions' },
			{ name: 'OPINIONES', active: false, flag: 'opinions' },
		],
		dialog: false,
		dialogVisible: false,
		disabled: false,
		isLoading: false,
		products: [],
		tabs: [],
		select: {},
		product: {
			sections: [],
		},
		childrens: [],
		allFeatures: [],
		features: [],
		filter: [],
		featureSelect: [],
		productsFilter: [],
		featurePossible: [],
		arrayPossible: [],
		images: [],
		productDetail: {},
		productSelect: {},
		disabledBtn: false,
		listQuestions: [],
		listOpinions: [],
		productModal: {},
		idProduct: null,
	};
}

export default {
	name: 'Products',
	components: {
		appTab,
		detailProduct,
		modalAction,
		tabs,
		warehouseModal,
	},
	computed: {
		...mapGetters([
			'token',
			'getCurrencySymbol',
			'getCommerceData',
		]),
	},
	data,
	created,
	methods: {
		assignProduct,
		changeQuantity,
		closeModal,
		closeModalAction,
		filterProduct,
		goToCar,
		isLoggedUser,
		loadData,
		loadDataQuestion,
		loadOpinion,
		loadProduct,
		openModal,
		openModalAction,
		possibleFeature,
		productsRelated,
		routeHandler,
		selectFeature,
		selectTab,
		setProductPrices,
		setUpTabs,
		selectedUnit,
		updateImages,
		updatePrices,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
	watch: {
		$route: routeHandler,
	},
};
</script>
<style lang="scss" scoped>
.product-disabled {
	align-items: center;
	display: flex;
	height: 300px;
	justify-content: center;
}

.sorry-text {
	margin: 0 20px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// Products.vue?d4c7b436